import * as _ from 'lodash';
import { TromanError } from '../../common/TromanError';

function makeParams(src) {
    var ret = {};
    var key;
    for (key in src) {
        if (Object.prototype.hasOwnProperty.call(src, key)) {
            ret[key] = true;
        }
    }
    return ret;
}

export class ReportInfo {
    constructor(report) {
        if (report == null) throw new TromanError('reportinfo_argnull');

        _.extend(this, report);

        if (report.Identifier) {
            this.display = report.Identifier + ' ' + report.Name;
        } else {
            this.display = report.Name;
        }

        this.params = {
            Query: makeParams(report.Defaults.Query),
            Options: makeParams(report.Defaults.Options)
        };
    }
}
